import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './error-message-severe.css'

export const ErrorMessageSevere = ({ error, lastEventId, market }) => (
  <div>
    <div styleName="contact-details">
      Sorry, an error has occurred. If the problem persists, please contact Support on
      <span styleName="strong">{market.tradedeskPhone}</span> or
      <a href={market.tradedeskEmail} styleName="link">{market.tradedeskEmail}</a> and
      provide the following information:
    </div>
    {lastEventId && <div>Error Code: <span styleName="strong">{lastEventId}</span>.</div>}
    {error.detail.statusCode && <div>Error Code: <span styleName="strong">{error.detail.statusCode}</span></div>}
    {error.detail.message && <div>Error Message: <span styleName="strong">{error.detail.message}</span></div>}
  </div>
)

ErrorMessageSevere.propTypes = {
  error: PropTypes.object,
  lastEventId: PropTypes.any,
  market: PropTypes.object,
}

export default CSSModules(ErrorMessageSevere, styles)



/** WEBPACK FOOTER **
 ** ./src/components/error-message/error-message-severe/error-message-severe.js
 **/